import React, { useCallback, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import Input from "../../../components/Common/Input/Input";
import { getSearchClassTagsActionHandler } from "../../../store/actions/actionHandlers/manageActionHandler";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../components/Common/Button/Button";
import classes from "./CreateCollection.module.scss";
import {
  isCollectionNameExistsActionHandler,
  postCollectionActionHandler,
} from "../../../store/actions/actionHandlers/distributeActionHandler";
import { FormattedMessage } from "react-intl";

const CreateCollection = ({ setIsCreateCollectionModal }) => {
  const dispatch = useDispatch();
  const methods = useForm({});
  const { handleSubmit } = methods;
  const [validTagSearch, setValidTagSearch] = useState(true);
  const [searchTagsList, setSearchTagsList] = useState([]);
  const distributeState = useSelector((state) => state.distributeReducer);
  const { selctedShotclassData } = distributeState;
  const [loader, setLoader] = useState(false);
  const [nameLoader, setNameLoader] = useState(false);
  const [duplicateNameError, setDuplicateNameError] = useState(false);
  const [selectedSearchTags, setSelectedSearchTags] = useState([]);
  const [collectionName, setCollectionName] = useState("");

  const handleSearchTags = useCallback(
    (e) => {
      let val = e.target.value.trim() !== "" && e.target.value;
      if (val) {
        if (/^[A-Za-z0-9@# ]+$/.test(val)) {
          setValidTagSearch(true);
          dispatch(
            getSearchClassTagsActionHandler(e.target.value, setSearchTagsList)
          );
        } else {
          setValidTagSearch(false);
        }
      } else {
        setValidTagSearch(true);
        setSearchTagsList([]);
      }
    },
    [dispatch]
  );

  const onSubmit = (data) => {
    let shotClassList = "",
      tags = "";
    selctedShotclassData?.forEach((item, index) => {
      shotClassList =
        shotClassList +
        item?.ID +
        (selctedShotclassData?.length !== index + 1 ? ";" : "");
    });
    data?.tags?.forEach((item, index) => {
      tags =
        tags + item?.TagName + (data?.tags?.length !== index + 1 ? "," : "");
    });
    const obj = {
      Count: 0,
      Name: data?.user,
      Order: "0",
      PageNum: 1,
      ShotClassList: shotClassList,
      Tags: tags,
      Type: "Collection",
    };
    setSelectedSearchTags(tags);
    dispatch(
      postCollectionActionHandler(obj, setLoader, setIsCreateCollectionModal)
    );
  };

  const handleNameChange = (e) => {
    const val = e?.target?.value;
    setCollectionName(val);
    dispatch(
      isCollectionNameExistsActionHandler(
        val,
        setNameLoader,
        setDuplicateNameError,
        "Collection"
      )
    );
  };

  return (
    <FormProvider {...methods}>
      <form
        className={classes.create_collection}
        onSubmit={handleSubmit(onSubmit)}
      >
        <Input
          label={<FormattedMessage id="NAME_TEXT" />}
          name="user"
          placeholder="Enter collection name"
          labelColor={"light"}
          onChange={handleNameChange}
          loading={nameLoader}
          error={duplicateNameError}
        />
        <Input
          label={<FormattedMessage id="SEARCH_TAGS_TEXT" />}
          name="tags"
          type="tags"
          fieldName="TagName"
          fieldValue="TagValue"
          placeholder="Enter multiple values"
          labelColor={"light"}
          searchTagsList={searchTagsList}
          onChange={handleSearchTags}
          isValidTagSearch={validTagSearch}
        />
        <div className={classes.btn}>
          <Button
            type="submit"
            label={<FormattedMessage id="P_SAVE_TXT" />}
            small
            dark
            backgroundColor={loader ? undefined : "#D31B61"}
            loading={loader}
            disabled={
              collectionName === "" || selectedSearchTags?.length === 0
                ? true
                : false
            }
          />
        </div>
      </form>
    </FormProvider>
  );
};

export default CreateCollection;
